<template>
  <v-container fluid>
    <v-radio-group
      v-model="model"
      v-bind="{...radioGroup}"
    >
      <template v-if="component.label" v-slot:label>
        <label>
          {{ component.label }}
        </label>
      </template>
      <v-radio
        v-for="(option, index) in options"
        :key="index"
        :label="option.label"
        :value="option.value"
        :name="component.name ? component.name : ''"
      />
    </v-radio-group>
  </v-container>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    component: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    // https://vuetifyjs.com/en/api/v-radio-group/
    radioGroup() {
      return _.get(this.component, 'props.radioGroup', {})
    }
  },
}
</script>

<style lang="scss" scoped></style>
